import {
  FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_REQUEST,
  FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_SUCCESS,
  FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_FALUIRE,
} from './thermitUnitDetailByUnitIDTypes'

const initialState = {
  loading: false,
  thermitUnitDetailByUnitID: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_SUCCESS : return {
      ...state,
      thermitUnitDetailByUnitID: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_THERMIT_UNIT_DETAIL_BY_UNIT_ID_FALUIRE : return {
      ...state,
      loading: false,
      thermitUnitDetailByUnitID: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
